import { useState } from 'react';
import { useParams } from 'react-router-dom';
import LeadRecordPageBase from './LeadRecordPageBase';
import LeadSourcePortal from '../components/LeadSourcePortal';
import LeadIdentityPortal from '../components/LeadIdentityPortal';
import QualificationSubmissionPortal from '../components/QualificationSubmissionPortal';
import '../source-restoration.css';
import '../lead-source-record-override.css';

export default function LeadRecordPage(){
  const { leadId } = useParams();
  const [identityRevision,setIdentityRevision] = useState(0);
  return <>
    <LeadRecordPageBase key={`record-${identityRevision}`} />
    <LeadIdentityPortal key={`identity-${identityRevision}`} leadId={leadId} onUpdated={()=>setIdentityRevision(value=>value+1)} />
    <LeadSourcePortal key={`source-${identityRevision}`} leadId={leadId} />
    <QualificationSubmissionPortal key={`submission-${identityRevision}`} leadId={leadId} />
  </>;
}
